import React from 'react';
import NavBar from "./components/NavBar/navBar";
import Intro from './components/Intro/intro';
import Skills from "./components/Skills/skills";
import Works from "./components/Works/works";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/footer";
import './assets/style.css';

function App() {
  return (
    <div className="App">
      <NavBar />  
      <Intro />
      <Skills />
      <Works />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
